import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { getStyles, translate, createArray } from '../../shared/utility';

import Gallery from '../../components/UI/Gallery/Gallery';
import FilterButtons from '../../components/UI/FilterButtons/FilterButtons';
import HorizontalScroll from '../../components/UI/HorizontalScroll/HorizontalScroll';
import Card from '../../components/UI/Card/Card';

import NearbyItems from './NearbyItems/NearbyItems';

import localStyles from './Home.scss';
const styles = getStyles(localStyles);

class Home extends Component {
    componentDidMount() {
        if (!this.props.popularLocationsData.length) {
            // this.props.onFetchPopularLocations();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!!this.props.currentLocationData && !this.props.nearbyItemsData.length && prevProps.nearbyItemsLoading === this.props.nearbyItemsLoading) {
            this.props.onFetchNearbyItems(this.props.currentLocationData);
        }
    }

    onMainTypeChange = (id) => {
        const location = !!this.props.activeSearchLocation ? `?location=${this.props.activeSearchLocation.id}` : null;
        const itemTypes = this.props.selectedItemTypeIds.length ? `${location ? '&' : '?'}itemTypes=${this.props.selectedItemTypeIds.toString()}` : null;
        const urlSearch = `${location ? location : ''}${itemTypes ? itemTypes : ''}`;

        this.props.history.push({ pathname: `/items/${id}`, search: urlSearch });
    }

    handleLocationClick = (location = null) => {
        const activeLocation = location ? {
            value: location.name,
            id: location.id,
            lat: location.gpsLatitude,
            lng: location.gpsLongitude
        } : null;

        this.props.onSetGlobalState('activeSearchLocation', activeLocation);
    }

    render() {
        // Sub filters data
        const mainTypesArray = createArray(this.props.mainTypesData);

        const filterSectionContent = mainTypesArray.length || this.props.mainTypesLoading ? (
            <Fragment>
                <h4>{translate('pages.home.filtersTitle', this.props.language)}</h4>
                <div className={styles('content', 'content--padding-vertical')}>
                    <FilterButtons
                        buttons={mainTypesArray}
                        identifier={'home-main-filters'}
                        changeEvent={this.onMainTypeChange}
                        classes={styles('home__filters')}
                        backgroundColor={'#f2f4f9'}
                        loading={this.props.mainTypesLoading}
                    />
                </div>
            </Fragment>
        ) : null;

        const locationsSectionContent = this.props.popularLocationsLoading || this.props.popularLocationsData.length ? (
            <ul className={styles('no-list-style', 'home__locations', 'flex')}>
                {this.props.popularLocationsLoading ? [0, 1, 2].map(item => (
                    <li key={item} className={styles('home__locations__card')}>
                        <Card item={item} viewMode={'card'} />
                    </li>
                )) : this.props.popularLocationsData.length ? this.props.popularLocationsData.map((location, index) => location.imageReferences.length ? (
                    <li key={index} className={styles('home__locations__card')} onClick={() => this.handleLocationClick(location)}>
                        <Gallery images={location.imageReferences} />
                        <h6 className={styles('home__locations__title')}>{location.name}</h6>
                    </li>
                ) : null) : null}
            </ul>
        ) : null;

        return this.props.mainTypesData.length === 1 ? <Redirect to={`items/${this.props.mainTypesData[0].id}`} /> : (
            <Fragment>
                <div className={styles('container', 'container--padding-evenly', 'b--gray-1')}>
                    <div className={styles('content')}>
                        {filterSectionContent}
                    </div>
                </div>

                {!this.props.popularLocationsData.length && !this.props.popularLocationsLoading && !this.props.popularLocationsError ? null : (
                    <div className={styles('container', 'container--padding-evenly')}>
                        <div className={styles('content', 'content--margin-vertical')}>
                            <h4>{translate('pages.home.locations', this.props.language)}</h4>
                            <div className={styles('content', 'content--padding')}>
                                <HorizontalScroll noOverlay selectorQuery={'li'} buttonSize={'xl'}>{locationsSectionContent}</HorizontalScroll>
                            </div>
                        </div>
                    </div>
                )}

                <NearbyItems
                    data={this.props.nearbyItemsData}
                    loading={this.props.nearbyItemsLoading}
                    error={this.props.nearbyItemsError}
                    language={this.props.language}
                />

            </Fragment>
        );
    }
}

Home.propTypes = {
    // properties
    history: PropTypes.object.isRequired,
    activeMainType: PropTypes.object,
    activeSearchLocation: PropTypes.object,
    selectedItemTypeIds: PropTypes.arrayOf(PropTypes.number),

    mainTypesData: PropTypes.arrayOf(PropTypes.object),
    mainTypesLoading: PropTypes.bool,
    currentLocationData: PropTypes.object,

    popularLocationsData: PropTypes.arrayOf(PropTypes.object),
    popularLocationsLoading: PropTypes.bool,
    popularLocationsError: PropTypes.string,
    nearbyItemsData: PropTypes.arrayOf(PropTypes.object),
    nearbyItemsLoading: PropTypes.bool,
    nearbyItemsError: PropTypes.string,

    language: PropTypes.string.isRequired,

    // functions
    onFetchPopularLocations: PropTypes.func.isRequired,
    onFetchNearbyItems: PropTypes.func.isRequired,
    onSetGlobalState: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        activeMainType: state.global.activeMainType,
        activeSearchLocation: state.global.activeSearchLocation,
        selectedItemTypeIds: state.global.selectedItemTypeIds,

        mainTypesData: state.list.mainTypes.data,
        mainTypesLoading: state.list.mainTypes.loading,
        currentLocationData: state.details.currentLocation.data,

        popularLocationsData: state.list.popularLocations.data,
        popularLocationsLoading: state.list.popularLocations.loading,
        popularLocationsError: state.list.popularLocations.error,
        nearbyItemsData: state.list.nearbyItems.data,
        nearbyItemsLoading: state.list.nearbyItems.loading,
        nearbyItemsError: state.list.nearbyItems.error,

        language: state.global.localization.language
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchPopularLocations: (listRange) => dispatch(actions.fetchPopularLocations(listRange)),
        onFetchNearbyItems: (location) => dispatch(actions.fetchNearbyItems(location)),
        onSetGlobalState: (identifier, value) => dispatch(actions.setGlobalState(identifier, value))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js